import * as React from 'react';
import { TableFetchParams, tableQueryMaker } from '@core/table';
import { useService } from '@core/inversify-react';

import { GetDeclarationsRepoType, IGetDeclarationsRepo } from '../../repos';

export const useDeclarationTableContext = () => {
  const getDeclarationsRepo = useService<IGetDeclarationsRepo>(GetDeclarationsRepoType);

  const handleFetch = React.useCallback(
    async (params: TableFetchParams) => {
      const result = await getDeclarationsRepo.execute(tableQueryMaker(params));

      if (result.status === 200) {
        return {
          data: result.response.data,
          total: result.response.total,
        };
      } else {
        throw new Error(result.response);
      }
    },
    [getDeclarationsRepo],
  );

  return { handleFetch };
};
